import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CourseRankFormComponent } from '../course-rank-form/course-rank-form.component';

@Component({
  selector: 'app-course-rank-page',
  templateUrl: './course-rank-page.component.html',
  styleUrls: ['./course-rank-page.component.css'],
  standalone: false,
})
export class CourseRankPageComponent implements OnInit {
  public filterClosed: boolean = false; //if filter is closed
  public filterOpened: boolean = true; //if filter is opened
  public pending: boolean = false;

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {}

  // open pop up dialog when in mobile mode if filter is clicked
  openDialog() {
    this.dialog
      .open(CourseRankFormComponent)
      .componentInstance.pendingEmitter.subscribe((pending) => {
        this.pending = pending;
      });
  }

  handlePending(pending: boolean) {
    this.pending = pending;
  }
}
